import {
  FONT_CALIBRE_SCHOOL,
  FONT_NSW_HANDWRITING,
} from 'approot/shared/styles/typography.style';
import {
  COLOUR_AZURE,
  COLOUR_BLACK,
  COLOUR_BLUE,
  COLOUR_CYAN,
  COLOUR_GOLD,
  COLOUR_GREEN,
  COLOUR_LIME,
  COLOUR_MAGENTA,
  COLOUR_ORANGE,
  COLOUR_PURPLE,
  COLOUR_RED,
  COLOUR_VOLCANO,
} from '../colour/colour.constants';

export const BLOCK_STYLE_PARAGRAPH = 'paragraph';
export const BLOCK_STYLE_PARAGRAPH_SMALL = 'small';

export type BlockStyle =
  | typeof BLOCK_STYLE_PARAGRAPH
  | typeof BLOCK_STYLE_PARAGRAPH_SMALL;

export type FontFamily =
  | typeof FONT_CALIBRE_SCHOOL
  | typeof FONT_NSW_HANDWRITING;

export const TEXT_ALIGN_LEFT = 'left';
export const TEXT_ALIGN_RIGHT = 'right';
export const TEXT_ALIGN_CENTRE = 'center';

export type TextAlign =
  | typeof TEXT_ALIGN_LEFT
  | typeof TEXT_ALIGN_RIGHT
  | typeof TEXT_ALIGN_CENTRE;

export const RICHTEXT_COLOUR_PALETTE = [
  COLOUR_BLACK,
  COLOUR_MAGENTA,
  COLOUR_RED,
  COLOUR_VOLCANO,
  COLOUR_ORANGE,
  COLOUR_GOLD,
  COLOUR_LIME,
  COLOUR_GREEN,
  COLOUR_CYAN,
  COLOUR_BLUE,
  COLOUR_AZURE,
  COLOUR_PURPLE,
];
